import styled from "styled-components";

interface LoadingStateProps {
    title?: string;
    subtitle?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
    title = "Loading...",
    subtitle = "Please wait while we fetch the data."
}) => {
    return (
        <div className="state-container">
            <div className="spinner" />
            <h4 className="state-title">{title}</h4>
            <p className="state-subtitle">{subtitle}</p>
        </div>
    );
};

export default LoadingState;
